function connectQuery(query) {
    const arr = [];
    Object.keys(query).forEach(key => {
        if (key && key !== 'token' && query[key]) {
            arr.push(`${key}=${query[key]}`);
        }
    });
    return arr.join('&');
}

function getUrlParam(url) {
    let query = url || window.location.search.substring(1);
    query = query.replace(/&amp;/g, '&');
    const vars = query.split('&');
    const params = {};
    for (let i = 0; i < vars.length; i += 1) {
        const [key, value] = vars[i].split('=');
        if (key && value) {
            params[key] = value;
        }
    }
    return params;
}
const randomPath = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hour = date.getHours();
    const minute = date.getMinutes();
    return `${year}${month}${day}${hour}${minute}`;
};

function isMiniProgram() {
    const ua = navigator.userAgent || '';
    // __wxjs_environment 在微信小程序 webview 环境中会被注入为 'miniprogram'
    if (typeof window !== 'undefined' && window.__wxjs_environment === 'miniprogram') {
        return true;
    }
    // UA 兜底（不同微信版本可能大小写不同）
    if (/miniprogram/i.test(ua)) return true;

    return false;
}

function randomUid(len = 10) {
    // 随机的uid值
    const map = '123456789';
    let res = '';
    const mapLen = map.length;
    for (let i = 0; i < len; i += 1) {
        const num = parseInt(Math.random() * mapLen, 10);
        res += map[num];
    }
    return res;
}

// 随机字符串
function randomStringUp(length = 32) {
    const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let result = '';
    for (let i = length; i > 0; ) {
        result += chars[Math.floor(Math.random() * chars.length)];
        i -= 1;
    }
    return result;
}
function clearCookie() {
    const keys = document.cookie.match(/[^ =;]+(?=)/g);
    console.log(keys);
    if (keys) {
        // eslint-disable-next-line
        for (let i = keys.length; i--; ) document.cookie = `${keys[i]}=0;expires=${new Date(0).toUTCString()}`;
    }
}

export { getUrlParam, connectQuery, randomPath, isMiniProgram, randomUid, randomStringUp, clearCookie };
